import { render, staticRenderFns } from "./ModalDetalhesOportunidade.vue?vue&type=template&id=ae2b1c92&scoped=true"
import script from "./ModalDetalhesOportunidade.vue?vue&type=script&lang=js"
export * from "./ModalDetalhesOportunidade.vue?vue&type=script&lang=js"
import style0 from "./ModalDetalhesOportunidade.vue?vue&type=style&index=0&id=ae2b1c92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae2b1c92",
  null
  
)

export default component.exports